import { Record } from "immutable";
import type { TextBlockConfiguration } from "models/interfaces/block-configurations/text-block-configuration";
import {
    blockConfigurationDefaultValuesFactory,
    BlockConfigurationRecord,
} from "models/view-models/block-configurations/block-configuration-record";
import StringUtils from "utilities/string-utils";

const defaultValues: TextBlockConfiguration =
    blockConfigurationDefaultValuesFactory<TextBlockConfiguration>({
        content: "",
    });

export class TextBlockConfigurationRecord
    extends Record(defaultValues)
    implements TextBlockConfiguration, BlockConfigurationRecord
{
    constructor(params?: Partial<TextBlockConfiguration>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    public with(
        values: Partial<TextBlockConfiguration>
    ): TextBlockConfigurationRecord {
        return new TextBlockConfigurationRecord(
            Object.assign(this.toJS(), values)
        );
    }

    /* Convenience methods to get encoded/decoded content for rendering and saving */
    public getRenderableContent(): string {
        return StringUtils.toRenderableHtml(this.content ?? "");
    }

    public getServerSafeContent(): string {
        return StringUtils.toServerSafeHtml(this.content ?? "");
    }
}
